import React, { useCallback, useMemo, useRef } from "react";
import { Principal } from "@codeArt/auth";
import { useDispatch, useSelector } from "react-redux";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import { go } from "@codeArt/apps/app";
import lazy from "@codeArt/apps/lazy";
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { roleCodes } from "../../partials/auth"
import SolutionApp from "./app";
import { getRoutes, getMenus } from "@codeArt/apps/page/tenant/auth/export";
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';

import _ from "lodash";

export const platformEN = "solution";

function getUserMenus(matchUrl) {
  let items = [
    {
      name: "个人档案",
      icon: <AssignmentIndIcon />,
      type: "item",
      link: `${matchUrl}/setting/info/index`
    },
    {
      name: "预约提醒设置",
      icon: <NotificationImportantIcon />,
      type: "item",
      link: `${matchUrl}/notice/info/index`
    }
  ]

  let menus = [...getMenus(`${matchUrl}/setting`, { platformEN: platformEN })];


  menus.forEach((t) => {
    items.push(t);
  });


  return items;
}

let getSidebar = function ({ matchUrl }) {

  let auther = Principal.getAuther();

  const menus = [
    {
      name: "开始",
      type: "section",
      children: [
      ]
    },
    {
      name: "用户控制",
      type: "section",
      children: getUserMenus(matchUrl)
    }
  ];


  const buttons = [

  ];

  let passage = [];

  if (auther.sa()) {
    passage.push({
      label: "系统配置",
      icon: <SettingsOutlinedIcon />,
      onClick: () => {
        go("/admin");
      }
    });
  }

  return { menus, buttons, passage };
};


function Router(id) { //项目编号

  const matchUrl = `/solution/${id}`;

  this.getMatchUrl = () => matchUrl;

  const routes = [
    {
      path: `${matchUrl}/home`,
      component: lazy(() => import("./home")),
    },
    {
      path: `${matchUrl}/setting/info/index`,
      component: lazy(() => import("@codeArt/apps/page/user/info/index"))
    },
    {
      path: `${matchUrl}/notice/info/index`,
      component: lazy(() => import("./notice/index"))
    },

    ...getRoutes(`${matchUrl}/setting`)
  ];

  this.getRoutes = () => {
    return routes;
  }

  this.getHome = () => {
    return routes[0].path;
  }
}


const Solution = ({ match, location }) => {
  const dispatch = useDispatch();

  const solutionId = getSolutionId(location);

  const footer = { hidden: true };

  const getLayout = (data) => {
    return {
      header: { logo: data.logo },
      footer,
    }
  }

  let router = useCallback(() => new Router(solutionId), [])();

  return (
    <SolutionApp
      solutionId={solutionId}
      location={location}
      routes={router.getRoutes()}
      getLayout={(data) => getLayout(data)}
      getMatchUrl={() => { return router.getMatchUrl() }}
      getSidebar={() => getSidebar({ matchUrl: router.getMatchUrl() })}
    >
    </SolutionApp>
  );
};

export default Solution;

function getSolutionId(location) {
  return parseInt(location.pathname.split("/")[2]);
}

export function getHomePage(id) {  //id是项目编号
  let router = new Router(id);
  return router.getHome();
}
